import angular from 'angular';

export default class KformComponentsProvider {
	/* @ngInject */
	constructor() {
		/** @type {Object<string, any>} */
		this.components = {};

		/** @type {any} */
		this.groups = {
			__component: {
				title: 'Basic Components',
			},
			advanced: {
				title: 'Special Components',
			},
			layout: {
				title: 'Layout Components',
			},
			node: {
				title: null,
			},
		};
	}

	/**
	 * @param {string} name
	 * @param {any} group
	 */
	addGroup(name, group) {
		this.groups[name] = group;
	}

	/**
	 * @param {string} type
	 * @param {any} component
	 * @param {string} group
	 */
	register(type, component, group) {
		if (this.components[type]) {
			angular.extend(this.components[type], component);
		}
		else {
			this.components[type] = component;
		}

		// Set the type for this component.
		if (!this.components[type].group) {
			this.components[type].group = group || '__component';
		}
		this.components[type].settings.type = type;
	}

	/* @ngInject */
	$get() {
		return {
			components: this.components,
			groups:     this.groups,
		};
	}
}
